import _ from 'underscore';
import { Areas } from '@bingads-webui-campaign-react/pmax-overview-data';

import { getCampaignStatus } from './get-campaign-status';
import { getEditorialStatus } from './get-editorial-status';
import { getBiddingStatus } from './get-bidding-status';
import { getConversionStatus, isConversionApplicable } from './get-conversion-status';

export function getDiagnosticsDetail({
  diagnosticsData,
  i18n,
  scope,
  activity,
  serverContext,
  alertHelper,
  areas,
  campaignType,
}) {
  activity.trace(`getDiagnosticsDetail - diagnosticsData: ${JSON.stringify(diagnosticsData)}`);
  const details = _.get(diagnosticsData, 'CampaignDiagnosticDetail', []);
  const locale = _.get(serverContext, ['CurrentLocale'], 'en-us').toLowerCase().split('-')[0];

  const result = {};

  if (areas.includes(Areas.Campaign)) {
    const campaignDetails = _.findWhere(details, { Key: 'Campaign' });
    result[Areas.Campaign] = getCampaignStatus({
      details: campaignDetails, scope, i18n, activity, locale, alertHelper,
    });
  }

  if (areas.includes(Areas.Editorial)) {
    const editorialDetails = _.findWhere(details, { Key: 'EditorialStatus' });
    result[Areas.Editorial] = getEditorialStatus({
      details: editorialDetails, scope, i18n, activity, locale, campaignType,
    });
  }

  if (areas.includes(Areas.Bidding)) {
    const biddingDetails = _.findWhere(details, { Key: 'Bidding' });
    result[Areas.Bidding] = getBiddingStatus({
      details: biddingDetails, scope, i18n, activity, locale,
    });
  }

  if (areas.includes(Areas.Conversion)) {
    const conversionDetails = _.findWhere(details, { Key: 'Conversion' });
    if (isConversionApplicable({ conversionDetails })) {
      result[Areas.Conversion] = getConversionStatus({
        details: conversionDetails, scope, i18n, activity, locale, serverContext, campaignType,
      });
    }
  }

  return result;
}
